import * as React from "react";
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';

const VideoField = (props) => {
    const record = useRecordContext(props);

    const styles = {
      videoContainer: {
        width: '100%',
        paddingTop: '56.25%',
        height: '0px',
        position: 'relative',
      },
      video: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
      }
    }

    return (
      <div style={styles.videoContainer}>
        <video poster={record['snapshot']} controls style={styles.video}>
          <source src={record['publication']} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    );
};

VideoField.propTypes = {
    record: PropTypes.object
};

export default VideoField;